import React, { Component }  from 'react'
import { Col, Row } from 'reactstrap';
import NumberFormat from "react-number-format";
import Form from 'react-bootstrap/Form';
import { InputGroup, Button, FormControl } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default class Payment extends Component {

	constructor(props) {
		super(props);
		this.state = {
			hiddenPass: true,
			passType: 'password',
		}
	}

	banks = () => {
		return (
			this.props.config_bank.map( (bank, key) => {
				return (
					<option value={bank.code} key={key}>{ bank.name }</option>
				)
			})
		)
	}

    onChange = (e, actionKey) => {
        let list_config_payment = [];
        this.props.list_config_payment.forEach( (config_payment, key) => {
            if ( key === actionKey ) {
            	config_payment[e.target.name] = e.target.value
            }
            list_config_payment.push(config_payment);
        })
        this.props.onChangeMethodPayment( 'list_config_payment', list_config_payment );
    }

    deletePayment = actionKey => () => {
    	let list_config_payment = [];
        this.props.list_config_payment.forEach( (config_payment) => {
            list_config_payment.push(config_payment);
        });
        list_config_payment.splice(actionKey, 1);
        this.props.onChangeMethodPayment( 'list_config_payment', list_config_payment );
    }

    addPayment = () => {
    	let list_config_payment = [];

        this.props.list_config_payment.forEach( (config_payment) => {
            list_config_payment.push(config_payment);
        });
        list_config_payment.push({
        	setting: '',
    		value: '',
    		content: '',
    		note: '',
        });
        this.props.onChangeMethodPayment( 'list_config_payment', list_config_payment );
    }

	selectBank = (config_payment, key) => {
		if ( this.props.config_bank.length ) {
            return (
                <Row className="form-group">
            		<Col md={2} className="col-form-label">
						<label>Chọn loại thanh toán</label>
					</Col>
					<Col md={10}>
					 	<Form.Select value={ config_payment.setting } onChange={(e) => this.onChange(e, key)} name="setting" className="form-control">
						  	<option>Chọn hình thức thanh toán</option>
						  	{
						  		this.banks()
						  	}
						</Form.Select>
					 </Col>
            	</Row>
            )
        }
	}

	listConfigPayment = () => {
		if ( this.props.list_config_payment.length ) {
			return (
				this.props.list_config_payment.map( (config_payment, key) => {
		            return (
		            	<div className="info-bank-config" key={key}>
			                <button type="button" className="close btnClose" onClick={this.deletePayment(key)} data-toggle="tooltip" data-placement="top" title="Xóa cấu hình thanh toán">
			                    <span aria-hidden="true">×</span>
			                </button>
			                <div className="group-bank-config">
			                	{
			                		this.selectBank(config_payment, key)
		                		}
			                	<Row className="form-group">
			                		<Col md={2} className="col-form-label">
										<label htmlFor={`account_name_${config_payment.id}`}>Tên tài khoản</label>
									</Col>
									<Col md={10}>
									 	<input type="text" value={config_payment.value} onChange={(e) => this.onChange(e, key)} className="form-control" id={`account_name_${config_payment.id}`} name="value" placeholder="Tên tài khoản" />
									</Col>
			                	</Row>
			                	<Row className="form-group">
			                		<Col md={2} className="col-form-label">
										<label htmlFor={`account_code_${config_payment.id}`}>Số tài khoản</label>
									</Col>
									<Col md={10}>
									 	<input type="text" value={config_payment.content} onChange={(e) => this.onChange(e, key)} className="form-control" id={`account_code_${config_payment.id}`} name="content" placeholder="Tên tài khoản" />
									</Col>
			                	</Row>
			                	<Row className="form-group">
			                		<Col md={2} className="col-form-label">
										<label htmlFor={`account_password_${config_payment.id}`}>Mật khẩu</label>
									</Col>
									<Col md={10}>
										<InputGroup className="mb-3">
										    <FormControl
										    	type={this.state.passType} 
										    	value={config_payment.note}
										    	onChange={(e) => this.onChange(e, key)}
										    	id={`account_password_${config_payment.id}`} 
										    	name="note"
										      	placeholder="Mật khẩu"
										      	aria-label="Mật khẩu"
										      	aria-describedby="basic-addon2"
										      	autoComplete="false"
										    />
										    <Button variant="outline-primary" id="button-addon2" onClick={ () => { this.setState({ hiddenPass: !this.state.hiddenPass, passType: this.state.hiddenPass ? 'text' : 'password' }) } }>
										    	{
										    		this.state.hiddenPass ? <FaEye /> : <FaEyeSlash />
										    	}
										    </Button>
										</InputGroup>

									</Col>
			                	</Row>
			                </div>
			                
		                </div>
	            	)
            	})
			)
		}
	}

	render() {
		return (
			<>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="payment_amount_min">Nạp tối thiểu</label>
					</Col>
					<Col md={10}>
						<NumberFormat
		              		thousandSeparator="."
              				decimalSeparator=","
              				// suffix=" ₫"
              				value={ this.props.payment.payment_amount_min } 
              				onChange={this.props.onChangeValue('payment')}
              				className="form-control" 
              				id="payment" 
              				name="payment_amount_min" 
              				placeholder="Số tiền nạp tối thiểu"
		              	/>
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="payment_amount_max">Nạp tối đa</label>
					</Col>
					<Col md={10}>
						<NumberFormat
		              		thousandSeparator="."
              				decimalSeparator=","
              				// suffix=" ₫"
              				value={ this.props.payment.payment_amount_max } 
              				onChange={this.props.onChangeValue('payment')}
              				className="form-control" 
              				id="payment_amount_max" 
              				name="payment_amount_max" 
              				placeholder="Số tiền nạp tối đa"
		              	/>
					</Col>
				</Row>
				<div className="add-info-pay my-4">
					{
						this.listConfigPayment()
					}
					<button type="button" className="btn btn-success" onClick={this.addPayment} data-toggle="tooltip" data-placement="top" title="Thêm thông tin thanh toán">
	                    <span aria-hidden="true">Thêm thông tin thanh toán</span>
	                </button>
				</div>

			</>
		)
	}
}